export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-thumbnail-480-dd3b38c1d572c4f25ef263eafecbcee8.png";